<template>
  <section>
    <div class="step-holder container">
      <div class="columns">
        <div class="column is-6 is-offset-3 stepbar-padding">
          <div class="lc-intro-block">
            <h3 class="intro">Before we start, let us know a little bit about you.</h3>
          </div>
          <form
            @submit.prevent="onSubmit"
          >
            <b-field
              horizontal
              label="name"
              class="lc-field"
            >
              <b-input
                v-model="form.name"
                autocomplete=”off”
                placeholder="enter name"
                @input="emitValidate"
              />
            </b-field>
            <b-field
              horizontal
              label="work email"
              class="lc-field"
            >
              <b-input
                v-model="form.email"
                placeholder="enter email"
                @input="emitValidate"
              />
            </b-field>
            <b-field
              horizontal
              label="role"
              class="lc-field"
            >
              <LCDropdownInput
                v-model="form.role"
                :options="['fashion designer', 'product designer', 'business designer', 'other']"
                placeholder="select"
                @input="emitValidate"
              />
            </b-field>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import LCDropdownInput from '@/components/leads_catcher/LCDropdownInput.vue'

  export default {
    name: 'Info',
    components: {
      LCDropdownInput
    },
    props: {
      form: Object
    },
    mounted() {
      this.emitValidate()
    },
    methods: {
      validate() {
        // return true
        return (this.form.name != '' &&
                this.form.email != '' &&
                this.form.role != '')
      },
      emitValidate() {
        this.$emit('validated', this.validate())
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
